import React, { Component } from "react";
import Header from "./components/header";
import PlayGorund from "./components/playgorund";
import User from "./components/user";
import Error from "./components/error";
import Rounds from "./components/rounds";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Predictions from "./components/prediction";
import Footer from "./components/footer";

class App extends Component {
  state = {
    userName: "",
    playerScore: 0,
    computerScore: 0,
    isLabel: "",
    round_num: 1,
    camInit: false,
    ramdomNum: 0,
    index: 0,
    imageUrl: "",
    prediction: "",
    result: "",
  };
  camRef = React.createRef();
  predictionRef = React.createRef();
  onQuit = () => {
    this.setState({
      userName: "",
      playerScore: 0,
      computerScore: 0,
      round_num: 1,
      randomNum: 0,
      index: 0,
      imageUrl: "",
      prediction: "",
      result: "",
    });
  };

  updateComputerScore = () => {
    this.setState({ computerScore: this.state.computerScore + 1 });
  };

  updatePlayerScore = () => {
    this.setState({ playerScore: this.state.playerScore + 1 });
  };

  updatePredict = (text) => {
    this.setState({ prediction: "You picked " + text + " !" });
  };

  updateResult = (text) => {
    this.setState({ result: text });
  };

  uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    this.setState({ imageUrl: window.URL.createObjectURL(file) });
    //console.log(window.URL.createObjectURL(file));
  };

  getName = (e) => {
    this.setState({ userName: e.target.value });
    if (e.target.value !== "") {
      this.setState({ isLabel: "Active" });
    } else {
      this.setState({ isLabel: "" });
    }
  };

  onCamInit = () => {
    this.setState({ camInit: true });
    this.genRandom();
  };

  onImgLoad = () => {
    this.setState({ prediction: "loading..." });
    this.predictionRef.current.detectImage();
  };

  genRandom = () => {
    const min = 1;
    const max = 4;
    const rand = min + Math.random() * (max - min);
    this.setState({ randomNum: Math.floor(rand) });
    // console.log("genRandom", this.state.randomNum);
  };

  onNextRound = () => {
    this.setState({
      round_num: this.state.round_num + 1,
      index: 0,
      imageUrl: "",
      prediction: "",
      result: "",
      random: "",
    });
    setTimeout(() => {
      this.genRandom();
    }, 4000);
    this.camRef.current.takePhotoAgain();
  };

  onInc = () => {
    if (this.state.index < 5) {
      this.setState({ index: this.state.index + 1 });
    }
  };

  render() {
    return (
      <Router>
        <React.Fragment>
          <Header></Header>
          <Switch>
            <Route path="/" exact>
              <User
                isLabel={this.state.isLabel}
                onGetName={this.getName}
              ></User>
              <Footer></Footer>
            </Route>
            <Route path="/game">
              <Rounds rounds={this.state.round_num}></Rounds>
              <PlayGorund
                index={this.state.index}
                name={this.state.userName}
                camInit={this.state.camInit}
                computerScore={this.state.computerScore}
                playerScore={this.state.playerScore}
                onCamInit={this.onCamInit}
                random={this.state.randomNum}
                onNext={this.onNextRound}
                onInc={this.onInc}
                imageUrl={this.state.imageUrl}
                uploadImage={this.uploadImage}
                ref={this.camRef}
                onImgLoad={this.onImgLoad}
                onQuit={this.onQuit}
              ></PlayGorund>
              <Predictions
                prediction={this.state.prediction}
                ref={this.predictionRef}
                updatePredict={this.updatePredict}
                random={this.state.randomNum}
                result={this.state.result}
                updateResult={this.updateResult}
                updateComputerScore={this.updateComputerScore}
                updatePlayerScore={this.updatePlayerScore}
              ></Predictions>
            </Route>
            <Route path="/error">
              <Error></Error>
            </Route>
          </Switch>
        </React.Fragment>
      </Router>
    );
  }
}

export default App;
